<template>
    <div class="main">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "TagMain",
    }
</script>

<style scoped>
    .main {
        position: relative;
        background: #FFFFFF;
        box-shadow: 0px 10px 28px 1px rgba(179, 187, 190, 0.18);
        border-radius: 20px;
        margin: 1em auto;
        padding-top: 1em;
        padding-bottom: 1em;
        width: 80%;
        min-width: 1500px;
        top: 0;
        transition: margin-left 250ms linear;
        z-index: 1;
        font-size: 14px;
    }
</style>